import { InnerContentItem, OuterContentItem } from "@certn/cascadia-react";
import { SubHeading } from "@certn/cascadia-react/components/summary-card/sub-heading/SubHeading";
import { components } from "@certn/legacy-api/generated-schemas/people";
import { formatDate } from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

export function ConvictionSummaryField({
  field,
}: {
  field: components["schemas"]["ConvictionsCheckField"];
}) {
  const { t } = useTranslation();

  return (
    <>
      <SubHeading>
        <Trans>CONVICTIONS</Trans>
      </SubHeading>

      {field.value.length === 0 && (
        <InnerContentItem
          textStyle="global/body-secondary"
          textColor="text-weak"
          testID="convictions-summary-none"
        >
          <Trans>None provided</Trans>
        </InnerContentItem>
      )}

      {field.value.map((conviction, index) => (
        <OuterContentItem
          title={`${conviction.offense} - ${conviction.description}`}
          subtitle={formatDate(conviction.date_of_sentence, "MMMM dd, yyyy")}
          key={conviction.id}
          testID={`convictions-summary-conviction-${index + 1}`}
        >
          <InnerContentItem
            label={t("Conviction offense")}
            testID={`convictions-summary-conviction-${index + 1}-offense`}
          >
            {conviction.offense} - {conviction.description}
          </InnerContentItem>
          <InnerContentItem
            label={t("Court location")}
            testID={`convictions-summary-conviction-${
              index + 1
            }-court-location`}
          >
            {conviction.court_location ?? "-"}
          </InnerContentItem>
          <InnerContentItem
            label={t("Date of sentence")}
            testID={`convictions-summary-conviction-${index + 1}-date`}
          >
            {formatDate(conviction.date_of_sentence, "MMMM dd, yyyy")}
          </InnerContentItem>
        </OuterContentItem>
      ))}
    </>
  );
}
